import { Box, Grid, GridItem, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import {
  AcceptedIcon,
  AssignedIcon,
  IncomingIcon,
  RejectedIcon,
  ForwardIcon,
} from "../../../assets/svgs/Icons";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import IncomingTC from "./IncomingTC";
import AssignedTC from "./AssignedTC";
import PendingTC from "./PendingTC";
import ForwardedToL2TC from "./ForwardedToL2TC";
import SentToClientTC from "./SentToClientTC";
import { countsForTCAdmin } from "./TCL1AdminSlice";
import isAllowed from "../../../routing/isAllowed";

const TransactionL1Approver = () => {
  const [page, setPage] = useState(0);
  const [status, setStatus] = useState("idle");
  const dispatch = useDispatch();
  const [isActive, setIsActive] = useState(0);
  const { counts } = useSelector(state => state.TCL1Admin);


  const navigate = useNavigate();

  let countForL1Admin = counts?.data?.["L1-TC-ISSUER"]
  const getCounts = () => {
    try {
      setStatus("pending")
      dispatch(countsForTCAdmin())
      setStatus("success")
    } catch (error) {
      setStatus("failed")

    }
  }

  const STEP_PAGES = [
    {
      id: 0,
      component: () => <IncomingTC />,
    },
    {
      id: 1,
      component: () => <AssignedTC />,
    },
    {
      id: 2,
      component: () => <PendingTC />,
    },
    {
      id: 3,
      component: () => <SentToClientTC />,
    },
    {
      id: 4,
      component: () => <ForwardedToL2TC />,
    },
  ];

  const handleTabClick = (tabIndex) => {
    setPage(tabIndex);
    // Updates localStorage with new active tab index
    localStorage.setItem("activeTab", tabIndex);
  };

  useEffect(() => {
    let storedActiveTab = localStorage.getItem("activeTab") || 0;
    if (storedActiveTab > STEP_PAGES.length - 1) {
      storedActiveTab = 0;
    }
    setPage(parseInt(storedActiveTab));
    setIsActive(parseInt(storedActiveTab));
  }, [page, isActive]);

  useEffect(() => {
    getCounts();
  }, [])

  return (
    <Box>
      <Box bg="#EDF3F8" marginTop="2rem">
        <Grid
          width={"100%"}
          templateColumns="repeat(5, 1fr)"
          my={"1rem"}
          gap="0.8rem"
          height={"100%"}
        >
          <GridItem>
            <Box
              bg={isActive === 0 ? "#fff" : "#B1DFFF"}
              color="#141D43
                            "
              width={"230px"}
              height={"178px"}
              cursor={"pointer"}
              borderRadius={"15px"}
              textAlign={"center"}
              d={"flex"}
              boxShadow={
                isActive === 0
                  ? " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
                  : ""
              }
              onClick={() => {
                handleTabClick(0);
              }}
            >
              <Grid templateColumns="repeat(2,1fr)">
                <GridItem mt={"3rem"}>
                  <IncomingIcon width="10" height="10" />
                </GridItem>

                <GridItem mt={"1rem"} mr={"1rem"}>
                  <Text fontWeight={"bold"} fontSize={"44px"}>
                    {countForL1Admin?.["INCOMING"] || 0}
                  </Text>
                  <Text fontSize={"24px"} fontWeight="500" textAlign={"left"}>
                    Incoming TC
                  </Text>
                </GridItem>
              </Grid>
            </Box>
          </GridItem>

          <GridItem>
            <Box
              bg={isActive === 1 ? "#fff" : "#B8C9EA"}
              color="#141D43
                            "
              width={"230px"}
              height={"178px"}
              cursor={"pointer"}
              borderRadius={"15px"}
              boxShadow={
                isActive === 1
                  ? " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
                  : ""
              }
              textAlign={"center"}
              onClick={() => {
                handleTabClick(1);
              }}
            >
              <Grid templateColumns="repeat(2,1fr)">
                <GridItem mt={"3rem"}>
                  <AssignedIcon width="10" height="10" />
                </GridItem>
                <GridItem mt={"1rem"} mr={"1rem"}>
                  <Text fontWeight={"bold"} fontSize={"44px"}>
                    {countForL1Admin?.["ASSIGNED"] || 0}
                  </Text>
                  <Text fontSize={"24px"} fontWeight="500" textAlign={"left"}>
                    Assigned TC
                  </Text>
                </GridItem>
              </Grid>
            </Box>
          </GridItem>
          <GridItem>
            <Box
              bg={isActive === 2 ? "#fff" : "#52BBFF"}
              color="#141D43"
              width={"230px"}
              height={"178px"}
              cursor={"pointer"}
              borderRadius={"15px"}
              textAlign={"center"}
              boxShadow={
                isActive === 2
                  ? " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
                  : ""
              }
              onClick={() => {
                handleTabClick(2);
              }}
            >
              <Grid templateColumns="repeat(2,1fr)">
                <GridItem mt={"3rem"}>
                  <AcceptedIcon width="10" height="10" />
                </GridItem>
                <GridItem mt={"1rem"} mr={"1rem"}>
                  <Text fontWeight={"bold"} fontSize={"44px"}>
                    {countForL1Admin?.["PENDING"] || 0}
                  </Text>
                  <Text fontSize={"24px"} fontWeight="500" textAlign={"left"}>
                    Pending TC
                  </Text>
                </GridItem>
              </Grid>
            </Box>
          </GridItem>
          <GridItem>
            <Box
              bg={isActive === 3 ? "#fff" : "#FE96A6"}
              color="#141D43
                            "
              width={"230px"}
              height={"178px"}
              cursor={"pointer"}
              borderRadius={"15px"}
              textAlign={"center"}
              boxShadow={
                isActive === 3
                  ? " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
                  : ""
              }
              onClick={() => {
                handleTabClick(3);
              }}
            >
              <Grid templateColumns="repeat(2,1fr)">
                <GridItem mt={"3rem"}>
                  <RejectedIcon width="10" height="10" />
                </GridItem>
                <GridItem mt={"1rem"} mr={"1rem"}>
                  <Text fontWeight={"bold"} fontSize={"44px"}>
                    {countForL1Admin?.["SEND-TO-CLINT"] || 0}
                  </Text>
                  <Text fontSize={"24px"} fontWeight="500" textAlign={"left"}>
                    Sent To Client
                  </Text>
                </GridItem>
              </Grid>
            </Box>
          </GridItem>

          <GridItem>
            <Box
              bg={isActive === 4 ? "#fff" : "#B1DFFF"}
              color="#141D43
                            "
              width={"230px"}
              height={"178px"}
              cursor={"pointer"}
              borderRadius={"15px"}
              textAlign={"center"}
              d={"flex"}
              boxShadow={
                isActive === 4
                  ? " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
                  : ""
              }
              onClick={() => {
                handleTabClick(4);
              }}
            >
              <Grid templateColumns="repeat(2,1fr)">
                <GridItem mt={"3rem"}>
                  <ForwardIcon width="10" height="10" />
                </GridItem>

                <GridItem mt={"1rem"} mr={"1rem"}>
                  <Text fontWeight={"bold"} fontSize={"44px"}>
                    {countForL1Admin?.["FORWARD"] || 0}
                  </Text>
                  <Text fontSize={"24px"} fontWeight="500" textAlign={"left"}>
                    Forwarded To L2 TC
                  </Text>
                </GridItem>
              </Grid>
            </Box>
          </GridItem>
        </Grid>
      </Box>
      {STEP_PAGES[page].component()}
      {/* child */}
    </Box>
  );
};

export default isAllowed(TransactionL1Approver);
